import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Media, Jumbotron } from 'reactstrap';
import UserProfileView from '../UserProfileView';

import './MenteeInfo.css'

export default class MenteeInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDetails: false
        }
    }

    toggleDetails() {
        const { showDetails } = this.state;
        this.setState({ showDetails: !showDetails });
    }

    render () {
        const { user, img, id } = this.props;
        if (!user) {
            return <div className="alert alert-info">Loading mentee information...</div>;
        }
        return (
            <Jumbotron className="mentee-info">
                <h3 className="section-title">Your Mentee</h3>
                <Media>
                    <Media left href={ `/mentee/${ id }` }>
                        <Media object src={ img } alt="Generic placeholder image" />
                    </Media>
                    <Media body>
                    <address>
                            <strong>Name</strong>
                            <br />
                            <span className="name">{ `${user.FirstName || ''} ${user.LastName || ''}` }</span>
                        </address>
                        {user.EmailAddress && (
                        <address>
                        <strong>Email</strong>
                            <br />
                            <a href={ `mailto:${ user.EmailAddress }` }>{ user.EmailAddress }</a>
                        </address>
                        )}
                        {user.Phone && (
                        <address>
                            <strong>Phone</strong>
                            <br />
                            <a href={ `tel:+1${ user.Phone }` }>{ user.Phone }</a>
                        </address>
                        )}                        <a className="btn btn-outline-secondary" onClick={() => this.toggleDetails() }>{ this.state.showDetails ? 'Less Details' : 'More Details' }</a>
                        <UserProfileView collapse={ !this.state.showDetails } { ...this.props } />
                    </Media>
                </Media>
            </Jumbotron>
        );
    }
}

MenteeInfo.propTypes = {
    id: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ])
    , name: PropTypes.string
    , email: PropTypes.string
    , phone: PropTypes.string
    , address: PropTypes.string
    , city: PropTypes.string
    , state: PropTypes.string
    , zip: PropTypes.number
    , img: PropTypes.string
};

MenteeInfo.defaultProps = {
    id: 1
    , name: 'Tom Jane'
    , email: 'tom.jane@mail.com'
    , phone: '(555) 555-5555'
    , address: '1234 Maple St'
    , city: 'Indianapolis'
    , state: 'IN'
    , zip: 46268
    , img: 'http://via.placeholder.com/96x96'
};
